// extracted by mini-css-extract-plugin
export default {"button":"ScrollButton_button__LYnQd"};